import {
  CHANGE_LAYOUT_DIMENSIONS,
  publishServiceRenderError,
} from '@corefront/redux-aba';
import { GO_TO_MAIN, SERVICE_RELOAD } from '../constants/service';

export const publishServiceRenderErrorByTimeout = () => {
  const payload = new Error('SERVICE (render): Timeout error on render phase.');

  return publishServiceRenderError(payload);
};

export const changeLayoutDimensions = () => ({
  type: CHANGE_LAYOUT_DIMENSIONS,
});
export const goToMain = () => ({ type: GO_TO_MAIN });
export const serviceReload = () => ({ type: SERVICE_RELOAD });
